import esContent from './sites.es';

export default {
  ...esContent,
};
